import React from 'react';
import styles from '../../../common/utils/styles/css/styles';
import useAuth from '../../utils/auth/useAuth';
import SigninForm from './SigninForm';
import {
  K_USER_STATUS_REJECTED,
  K_USER_STATUS_PENDING,
  K_USER_STATUS_BANNED
} from '../../shared/constants';
import UnverifiedEmail from './../../profile/components/status/UnverifiedEmail';
import Rejected from './../../profile/components/status/Rejected';
import Pending from './../../profile/components/status/Pending';
import Suspended from './../../profile/components/status/Suspended';
import { Margin } from '../../../common/base';
import TouchableItem from '../../../common/components/basic/TouchableItem';
import firebase from '../../../common/firebase';
import { useTranslation } from 'react-i18next';
import { Router } from '../../../common/libs/i18n';

function SigninState() {
  const { user } = useAuth();
  if (!user.emailVerified) {
    return <UnverifiedEmail />;
  } else if (user.status) {
    if (user.status.toLowerCase() === K_USER_STATUS_REJECTED.toLowerCase()) {
      return <Rejected />;
    } else if (user.status.toLowerCase() === K_USER_STATUS_PENDING.toLowerCase()) {
      return <Pending />;
    } else if (user.status.toLowerCase() === K_USER_STATUS_BANNED.toLowerCase()) {
      return <Suspended />;
    }
  }
  return null;
}

export default function SigninFormContainer() {
  const { t } = useTranslation();
  const { user } = useAuth();
  if (!user) return <SigninForm />;
  return (
    <div>
      <SigninState />
      <div css={styles.tac}>
        <Margin top={24}>
          <TouchableItem
            css={styles.fcp}
            onClick={async () => {
              firebase.auth().signOut();
              Router.push('/');
            }}
          >
            {t('signin.form.go_back_button', 'Go back')}
          </TouchableItem>
        </Margin>
      </div>
    </div>
  );
}
